import { coreApi } from '@cp/shared/api/core';
import { FAQViewModel, FaqCreateRequest, FaqUpdateRequest } from '@common/model/resource/faq';
import { FAQListRequest } from './request';
import { FAQListResponse } from './response';
import { CoreFaqApiTags, coreFaqApiTagTypes } from './tags';

export const coreResourceFAQListApi = coreApi.enhanceEndpoints({ addTagTypes: coreFaqApiTagTypes }).injectEndpoints({
  endpoints: (builder) => ({
    getFAQList: builder.query<FAQListResponse, FAQListRequest>({
      query: ({ routeId }) => ({
        url: `meta/client-web-routes/${routeId}/faq`,
      }),
      providesTags: (_r, _e, arg) => [{ type: CoreFaqApiTags.FAQList, id: arg.routeId }],
    }),
    createFAQ: builder.mutation<FAQViewModel, FaqCreateRequest>({
      query: (body) => ({
        url: `meta/client-web-routes/${body.routeId}/faq`,
        body,
        method: 'POST',
      }),
      invalidatesTags: (res) => [{ type: CoreFaqApiTags.FAQList, id: res?.routeId }],
    }),
    updateFAQ: builder.mutation<FAQViewModel, FaqUpdateRequest>({
      query: (body) => ({
        url: `meta/client-web-routes/${body.routeId}/faq/${body.id}`,
        body,
        method: 'PUT',
      }),
      invalidatesTags: (res) => [{ type: CoreFaqApiTags.FAQList, id: res?.routeId }],
    }),
  }),

  overrideExisting: false,
});
